import axios from 'axios'
import { API_URL } from 'services/config'

class FiltersService {
    getBrokers = () =>
        axios
            .get(`${API_URL}/brokers/children`)
            .then(({ data: { data } }) => data)

    getQuoteRisks = () =>
        axios
            .get(`${API_URL}/brokers/risk-types?entity=multi-quotes`)
            .then(({ data: { data } }) => data)

    getPolicyRisks = () =>
        axios
            .get(`${API_URL}/brokers/risk-types`)
            .then(({ data: { data } }) => data)

    getMyInsuranceCompanies = () =>
        axios
            .get(`${API_URL}/brokers/insurance-companies`)
            .then(({ data: { data } }) => data)

    getOrigins = () => 
        axios
            .get(`${API_URL}/groups`)
            .then(({ data: { data } }) => data)

    getInsuranceCompanies = () =>
        axios
            .get(`${API_URL}/insurance-companies`)
            .then(({ data: { data } }) => data)

    getInsuranceTypes = () =>
        axios
            .get(`${API_URL}/insurances`)
            .then(({ data: { data } }) => data)
}

export default FiltersService
